module.exports = __webpack_public_path__ + "images/namvhdf05ef5665ba68397ae5a4ecb6bc22531.png";